import { useTranslation } from 'react-i18next'
import { Press, Logo } from '@dorixona/ui'
import { formatAmount } from '@dorixona/utils'
import { usePoints } from './points'

export interface LoyaltyCardProps {
  /** Баллы: 1 балл = 1 сум. */
  balance: number
  onHistory: () => void
}

/**
 * Карта лояльности. Баланс — главное число экрана, под ним подсказка про QR
 * на кассе. Номер телефона и подпись «Мои заказы» убраны: заказы теперь во
 * вкладке нижней панели. Карта по-прежнему нажимается целиком и ведёт в
 * историю начислений.
 */
export function LoyaltyCard({ balance, onHistory }: LoyaltyCardProps) {
  const { t } = useTranslation(['home', 'account'])
  const { formatPoints, pointsUnit } = usePoints()

  return (
    <Press
      as="div"
      role="button"
      tabIndex={0}
      squish="card"
      className="loyalty"
      aria-label={`${t('home:loyalty.label')} ${formatPoints(balance)}. ${t('account:history.points')}`}
      onPress={onHistory}
    >
      <Logo className="l-card" onDark />
      <div className="lbl">{t('home:loyalty.label')}</div>
      <div className="bal num">
        {formatAmount(balance)} <small>{pointsUnit(balance)}</small>
      </div>
      <div className="idcap">{t('home:loyalty.idCaption')}</div>
    </Press>
  )
}
